<template>
  <v-dialog :value="value" max-width="800px" persistent :color="appButtonColor">
    <v-card>
      <v-card-title>
        <h2 class="headline pl-4">New Restricted User</h2>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md py-0 px-3>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newRestricted.a360id"
                label="A360ID"
                autofocus
                v-if="restrictedModal"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="appButtonColor" flat @click="empty">Cancel</v-btn>
        <v-btn :color="appButtonColor" flat @click="addRestricted">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "restrictedUser",
  props: ["value"],
  data() {
    return {
      newRestricted: {
        a360id: "",
      },
      newRestrictedCopy: {
        a360id: "",
      },
    };
  },
  created() {},
  computed: {
    ...mapState("accounts", ["restrictedModal", "restricted"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
  },
  methods: {
    ...mapMutations("accounts", ["setRestricted"]),
    empty() {
      this.setRestricted(false);
      this.newRestricted = JSON.parse(JSON.stringify(this.newRestrictedCopy));
    },
    async addRestricted() {
      if (!this.newRestricted.a360id) return;
      // check for duplicate restricted accounts
      let copies = this.restricted.findIndex((item) => {
        return item.a360id === this.newRestricted.a360id.trim();
      });
      if (copies !== -1) {
        this.empty();
        return;
      }

      let restricted = await this.$store.dispatch(
        "accounts/newRestricted",
        this.newRestricted.a360id.trim()
      );
      if (restricted) {
        this.empty();
      }
    },
    genPass() {
      this.newSponsor.password = this.$generate({
        length: 12,
        numbers: true,
        symbols: true,
        strict: true,
        exclude: "\"`'",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>